import React from "react";
import "./HowToPlay.css";

const HowToPlay = () => {
  return (
    <div className="how-to-play-container">
      <h2 className="title">How To Play</h2>
      <ol className="steps-list">
        <li>
          Download our application from Google Play Store or from our official
          website.
        </li>
        <li>
          Register with your Mobile Number, Email ID, and User Name on our
          platform.
        </li>
        <li>
          Login to the application using your Mobile Number and Password.
        </li>
        <li>
          Select the Game type, choose your favourite number, and start to play
          the game.
        </li>
        <li>Get a chance to win up to 10 Lac Points.</li>
      </ol>
    </div>
  );
};

export default HowToPlay;